import React, { FunctionComponent } from 'react';

import Row from '@/components/layout/Row';
import Col from '@/components/layout/Col';
import Header from '@/components/typography/Header';
import AnchoredCardImage from '@/components/landingPages/AnchoredCardImage';
import SectionDivider from '@/components/landingPages/SectionDivider';
import LocationGuideSection from '@/components/landingPages/LocationGuideSection';
import LandingPageContentSection from '@/components/landingPages/LandingPageContentSection';
import PrismicRichText from '@/components/design/PrismicRichText';
import {
  IPrismicNearbyAirport,
  IPrismicRichTextElement,
  IPrismicRoute,
} from '@/pageGeneration/services/prismicApi/types';

import SuggestedAirportsSection from '@/components/landingPages/SuggestedAirportsSection';
import RouteSection from '@/components/landingPages/RouteSection';
import { ILandingPageLink } from '@/pageGeneration/services/LandingPageService';
import LinksSection from "@/components/landingPages/LinksSection";
import styles from './InfoSection.module.scss';

interface IProps {
  title: string;
  subtitle?: IPrismicRichTextElement[];
  about?: IPrismicRichTextElement[];
  topImageUrl?: string;
  bottomImageUrl?: string;
  guide?: IPrismicRichTextElement[];
  nearbyAirports?: IPrismicNearbyAirport[];
  nearbyDestinationLinks?: ILandingPageLink[];
  routes?: IPrismicRoute[];
}

const InfoSection: FunctionComponent<IProps> = ({
  title,
  subtitle,
  about,
  topImageUrl,
  bottomImageUrl,
  guide,
  nearbyAirports,
  nearbyDestinationLinks,
  routes,
}) => (
  <div className={styles.base} data-testid="InfoSectionContainer">
    {!!nearbyAirports?.length && (
      <LandingPageContentSection>
        <SuggestedAirportsSection airports={nearbyAirports} />
      </LandingPageContentSection>
    )}
    {!!about?.length && (
      <LandingPageContentSection>
        <Row gutter={[30, 0]}>
          <Col xs={12} sm={12} md={8} lg={7} xl={7}>
            <SectionDivider />
          </Col>
        </Row>

        <Row gutter={[30, 0]}>
          <Col xs={24} sm={12} md={16} lg={16} xl={16}>
            <Header level={2} color="primary" strong marginBottom={2} style={{ marginTop: 10 }}>
              {title}
            </Header>
            <PrismicRichText items={subtitle} />
            <PrismicRichText items={about} />
          </Col>
          <Col xs={24} sm={12} md={8} lg={8} xl={8}>
            {topImageUrl && <AnchoredCardImage imageUrl={topImageUrl} height={250} style={{ marginTop: 25 }} />}
            {bottomImageUrl && <AnchoredCardImage imageUrl={bottomImageUrl} height={250} style={{ marginTop: 25 }} />}
          </Col>
        </Row>
      </LandingPageContentSection>
    )}
    {!!routes?.length && (
      <LandingPageContentSection>
        <RouteSection routes={routes} />
      </LandingPageContentSection>
    )}

    {!!nearbyDestinationLinks?.length && (
      <LandingPageContentSection>
        <LinksSection links={nearbyDestinationLinks} title="Nearby destinations" />
      </LandingPageContentSection>
    )}

    {!!guide?.length && !!guide[0]?.text?.length && (
      <LandingPageContentSection>
        <LocationGuideSection name={title} guide={guide} />
      </LandingPageContentSection>
    )}
  </div>
);

export default InfoSection;
